/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { LOCK_SEAT_DURATION_IN_SECONDS } from 'src/app/core/constants/review-summary';
import { AscentisMemberAuthentication } from 'src/app/core/models/ascentis-login/member-authentication';
import { BookingsHistory } from 'src/app/core/models/fast-ticket/bookings-history';
import { GetTicketListingModel } from 'src/app/core/models/fast-ticket/ticket-listing';
import { UserFavCinema } from 'src/app/core/models/favourite-cinema/favourite-cinema';
import { Films } from 'src/app/core/models/movie-listing/films';
import { AscentisQRToken } from 'src/app/core/models/profile/token';
import { Locations } from 'src/app/core/models/showtimes-by-movies/locations';
import { SelectedVariationModel } from 'src/app/core/models/ticket-pricing/variation.model';
import { GuestData } from 'src/app/pages/login-guest/login-guest.component';
import { environment } from 'src/environments/environment';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AES, Utf8 } from 'crypto-es';
import { ConfirmTicketTypeCache } from '../models/confirm-ticket-type/confirm-ticket-type-cache.model';
import { InitSalesResponseModel } from '../models/payment/initsales_response_body/initsales_response_model';
import { InitSalesTransaction } from '../models/payment/initsales_transaction/initsales_transaction';
import { MemberEnquiry } from '../models/profile/member-enquiry';
import { RegisterUserInfoBody } from '../models/register/register-user-info-body';
import { SeatSelectionCacheMain } from '../models/seat-selection/seat-selection-cache-main.model';
import { SeatSelectionModel } from '../models/seat-selection/seat-selection.model';
import { ShowtimeBannerDetails } from '../models/seat-selection/showtime-banner-details.model';
import { UpdateProfileModel } from '../models/update-profile/update-profile.model';
import { MyVoucherList } from '../models/voucher/my-voucher-list';
import { VoucherTypeList } from '../models/voucher/voucher-type-list';
import { MovieTicketType, UpsellingType } from '../enums/movie-type.enum';
import { RecommendDetails } from '../models/fast-ticket/recommended-showtime.model';
import { FnbData } from '../models/fnb/fnb-data';
import { FnbUpsell } from '../models/fnb/fnb-product/fnb-upsell';
import { FnbSalesTransaction } from '../models/payment/fnb/fnb-initsales/fnb-transaction';
import { FnbInitSalesResponseWrapper } from '../models/payment/fnb/fnb-initsales-response/fnb-initsales-response-wrapper';
import { InitSalesRequestBody } from '../models/payment/initsales_transaction/initsales_requestBody';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    private secretKey = 'This!sGscCinem@s';

    get userName(): string {
        return sessionStorage.getItem('userName') || '';
    }

    set userName(userName: string) {
        sessionStorage.setItem('userName', userName || '');
    }

    get memberCardNo(): string {
        return AES.decrypt(sessionStorage.getItem('memberCardNo') || '', this.secretKey).toString(Utf8);
    }

    set memberCardNo(memberCardNo: string) {
        sessionStorage.setItem('memberCardNo', AES.encrypt(memberCardNo || '', this.secretKey).toString());
    }

    get gscCoins(): number {
        return Number(AES.decrypt((sessionStorage.getItem('gscCoins') || ''), this.secretKey).toString(Utf8)) || 0;
    }

    set gscCoins(gscCoins: number) {
        sessionStorage.setItem('gscCoins', AES.encrypt(String(gscCoins), this.secretKey).toString());
    }

    get ticketData(): any {
        return AES.decrypt(sessionStorage.getItem('ticketData') || '', this.secretKey).toString(Utf8);
    }

    set ticketData(data: any) {
        sessionStorage.setItem('ticketData', AES.encrypt(data, this.secretKey).toString());
    }

    get mappingData(): any {
        return AES.decrypt(sessionStorage.getItem('mappingData') || '', this.secretKey).toString(Utf8);
    }

    set mappingData(data: any) {
        sessionStorage.setItem('mappingData', AES.encrypt(data, this.secretKey).toString());
    }

    set selectedShowtimesDetails(data: Locations | null) {
        sessionStorage.setItem('selectedShowtime', (AES.encrypt(JSON.stringify(data), this.secretKey).toString()));
    }

    get selectedShowtimesDetails(): Locations | null {
        return sessionStorage.getItem('selectedShowtime') ? JSON.parse(AES.decrypt(sessionStorage.getItem('selectedShowtime') || '', this.secretKey).toString(Utf8)) as Locations : null;
    }

    set showtimesApiModel(data: SeatSelectionModel | null) {
        sessionStorage.setItem('seatsShowtimeApi', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get showtimesApiModel(): SeatSelectionModel | null {
        return sessionStorage.getItem('seatsShowtimeApi') ? JSON.parse(AES.decrypt(sessionStorage.getItem('seatsShowtimeApi') || '', this.secretKey).toString(Utf8)) as SeatSelectionModel : null;
    }

    set showtimesBannerDetails(data: ShowtimeBannerDetails | null) {
        sessionStorage.setItem('bannerDetails', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get showtimesBannerDetails(): ShowtimeBannerDetails | null {
        return sessionStorage.getItem('bannerDetails') ? JSON.parse(AES.decrypt(sessionStorage.getItem('bannerDetails') || '', this.secretKey).toString(Utf8)) as ShowtimeBannerDetails : null;
    }

    set selectedEcomboDetails(data: SelectedVariationModel[]) {
        sessionStorage.setItem('eComboDetails', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get selectedEcomboDetails(): SelectedVariationModel[] {
        const data = sessionStorage.getItem('eComboDetails');
        if (data) { return JSON.parse(AES.decrypt(data, this.secretKey).toString(Utf8)) as SelectedVariationModel[]; }
        return [];
    }

    set selectedAddOnDetails(itm: SelectedVariationModel[]) {
        sessionStorage.setItem('addOnDetails', AES.encrypt(JSON.stringify(itm) ?? [], this.secretKey).toString());
    }

    get selectedAddOnDetails(): SelectedVariationModel[] {
        const data = sessionStorage.getItem('addOnDetails');
        if (data) { return JSON.parse(AES.decrypt(data, this.secretKey).toString(Utf8)) as SelectedVariationModel[]; }
        return [];
    }

    set selectedAurumBundleDetails(data: SelectedVariationModel[]) {
        sessionStorage.setItem('aurumBundleDetails', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get selectedAurumBundleDetails(): SelectedVariationModel[] {
        const data = sessionStorage.getItem('aurumBundleDetails');
        if (data) { return JSON.parse(AES.decrypt(data, this.secretKey).toString(Utf8)) as SelectedVariationModel[]; }
        return [];
    }

    set lockSeatBody(data: InitSalesTransaction | null) {
        sessionStorage.setItem('lockSeatBody', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get lockSeatBody(): InitSalesTransaction | null {
        return sessionStorage.getItem('lockSeatBody') ? JSON.parse(AES.decrypt(sessionStorage.getItem('lockSeatBody') || '', this.secretKey).toString(Utf8)) as InitSalesTransaction : null;
    }

    set upsellLockSeatBody(data: FnbSalesTransaction | null) {
        sessionStorage.setItem('upsellLockSeatBody', AES.encrypt(JSON.stringify(data) ?? '', this.secretKey).toString());
    }

    get upsellLockSeatBody(): FnbSalesTransaction | null {
        return sessionStorage.getItem('upsellLockSeatBody') ? JSON.parse(AES.decrypt(sessionStorage.getItem('upsellLockSeatBody') || '', this.secretKey).toString(Utf8)) as FnbSalesTransaction : null;
    }

    set bookingID(data: string | null) {
        sessionStorage.setItem('bookingID', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get bookingID(): string | null {
        return sessionStorage.getItem('bookingID') ? JSON.parse(AES.decrypt(sessionStorage.getItem('bookingID') || '', this.secretKey).toString(Utf8)) : null;
    }

    set initSalesResponse(data: InitSalesResponseModel | null) {
        sessionStorage.setItem('initResponse', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get initSalesResponse(): InitSalesResponseModel | null {
        return sessionStorage.getItem('initResponse') ? JSON.parse(AES.decrypt(sessionStorage.getItem('initResponse') || '', this.secretKey).toString(Utf8)) as InitSalesResponseModel : null;
    }

    set fnbInitSalesResponse(body: FnbInitSalesResponseWrapper | null) {
        sessionStorage.setItem('fnbInitSalesRes', AES.encrypt(JSON.stringify(body) ?? '', this.secretKey).toString());
    }

    get fnbInitSalesResponse(): FnbInitSalesResponseWrapper | null {
        return sessionStorage.getItem('fnbInitSalesRes') ? JSON.parse(AES.decrypt(sessionStorage.getItem('fnbInitSalesRes') ?? '', this.secretKey).toString(Utf8)) : null;
    }

    set fastTicketUserHistory(data: BookingsHistory | null) {
        sessionStorage.setItem('fastTicketUserHistory', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get fastTicketUserHistory(): BookingsHistory | null {
        return sessionStorage.getItem('fastTicketUserHistory')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('fastTicketUserHistory') || '', this.secretKey).toString(Utf8)) as BookingsHistory
            : null;
    }

    set fastTicketMovieListing(data: Films | null) {
        sessionStorage.setItem('fastTicketMovieListing', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get fastTicketMovieListing(): Films | null {
        return sessionStorage.getItem('fastTicketMovieListing')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('fastTicketMovieListing') || '', this.secretKey).toString(Utf8)) as Films
            : null;
    }

    set fastTicketShowtimes(data: Locations | null) {
        sessionStorage.setItem('fastTicketShowtimes', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get fastTicketShowtimes(): Locations | null {
        return sessionStorage.getItem('fastTicketShowtimes')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('fastTicketShowtimes') || '', this.secretKey).toString(Utf8)) as Locations
            : null;
    }

    set userMembershipInfo(data: GetTicketListingModel | null) {
        sessionStorage.setItem('userMembership', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get userMembershipInfo(): GetTicketListingModel | null {
        return sessionStorage.getItem('userMembership')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('userMembership') || '', this.secretKey).toString(Utf8)) as GetTicketListingModel
            : null;
    }

    set guestData(data: GuestData | null) {
        sessionStorage.setItem('guestData', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get guestData(): GuestData | null {
        return sessionStorage.getItem('guestData')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('guestData') || '', this.secretKey).toString(Utf8)) as GuestData
            : null;
    }

    set userFavouriteCinema(data: UserFavCinema[] | null) {
        sessionStorage.setItem('userFavouriteCinema', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get userFavouriteCinema(): UserFavCinema[] | null {
        return sessionStorage.getItem('userFavouriteCinema')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('userFavouriteCinema') || '', this.secretKey).toString(Utf8))
            : null;
    }

    set fastTicketReloadEventFlag(isRefresh: boolean) {
        sessionStorage.setItem('fastTicketReloadEventFlag', AES.encrypt(JSON.stringify(isRefresh), this.secretKey).toString());
    }

    get fastTicketReloadEventFlag(): boolean {
        return sessionStorage.getItem('fastTicketReloadEventFlag')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('fastTicketReloadEventFlag') || '', this.secretKey).toString(Utf8)) as boolean
            : false;
    }

    set registrationInfo(data: RegisterUserInfoBody | null) {
        sessionStorage.setItem('registrationInfo', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get registrationInfo(): RegisterUserInfoBody | null {
        return sessionStorage.getItem('registrationInfo')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('registrationInfo') || '', this.secretKey).toString(Utf8)) as RegisterUserInfoBody
            : null;
    }

    set countryCode(code: string) {
        sessionStorage.setItem('countryCode', AES.encrypt(code, this.secretKey).toString());
    }

    get countryCode(): string {
        return sessionStorage.getItem('countryCode') ? AES.decrypt(sessionStorage.getItem('countryCode') || '', this.secretKey).toString(Utf8) : '';
    }

    set mobileNo(no: string) {
        sessionStorage.setItem('mobileNo', AES.encrypt(no, this.secretKey).toString());
    }

    get mobileNo(): string {
        return sessionStorage.getItem('mobileNo') ? AES.decrypt(sessionStorage.getItem('mobileNo') || '', this.secretKey).toString(Utf8) : '';
    }

    set accessToken(data: string) {
        sessionStorage.setItem('accessToken', AES.encrypt(data, this.secretKey).toString());
    }

    get accessToken(): string {
        return sessionStorage.getItem('accessToken') ? AES.decrypt(sessionStorage.getItem('accessToken') || '', this.secretKey).toString(Utf8) : '';
    }

    set profileQRToken(data: AscentisQRToken | null) {
        sessionStorage.setItem('profileQrToken', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get profileQRToken(): AscentisQRToken | null {
        return sessionStorage.getItem('profileQrToken')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('profileQrToken') || '', this.secretKey).toString(Utf8)) as AscentisQRToken
            : null;
    }

    set reviewSummaryCountdown(time: number) {
        sessionStorage.setItem('reviewSummaryCountdown', AES.encrypt(JSON.stringify(time), this.secretKey).toString());
    }

    get reviewSummaryCountdown(): number {
        return sessionStorage.getItem('reviewSummaryCountdown')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('reviewSummaryCountdown') || '', this.secretKey).toString(Utf8)) as number
            : LOCK_SEAT_DURATION_IN_SECONDS;
    }

    clearFastTicket(): void {
        this.userFavouriteCinema = null;
        this.fastTicketMovieListing = null;
        this.fastTicketShowtimes = null;
        this.fastTicketUserHistory = null;
        this.selectedShowtimesDetails = null;
        this.mappingData = null;
        this.ticketData = null;
        this.showtimesApiModel = null;
        this.showtimesBannerDetails = null;
        this.confirmTicketTypeData = null;
        this.seatSelectionData = null;
        this.recommendedShowtimes = null;
        this.initSalesResponse = null;
        this.selectedEcomboDetails = [];
        this.selectedAurumBundleDetails = [];
        this.selectedAddOnDetails = [];
        this.reviewSummaryEntry = null;
        this.reviewSummaryCountdown = 0;
        this.reviewSummaryTimerDiff = null;
        this.clearFnbData();
        this.upsellProduct = null;
    }

    clearUserShowtimesSelection(): void {
        this.selectedShowtimesDetails = null;
    }

    set currentLanguage(language: string | null) {
        sessionStorage.setItem('currentLanguage', AES.encrypt(language ?? 'EN', this.secretKey).toString());
    }

    get currentLanguage(): string | null {
        return sessionStorage.getItem('currentLanguage') ? AES.decrypt(sessionStorage.getItem('currentLanguage') || 'EN', this.secretKey).toString(Utf8) : 'EN';
    }

    setFromLogin(input: AscentisMemberAuthentication): void {
        if (input.MemberLists) {
            this.userName = input.MemberLists[0].Name;
            this.userMembershipInfo = {
                curdt: moment().format(),
                mbrid: input.MemberLists[0].MemberID,
                emailid: input.MemberLists[0].Email,
                phoneno: input.MemberLists[0].MobileNo,
                token: '1',
            };
            const newMemberID = input.MemberLists[0].MemberID;

            if (!this.sameUser) {
                this.sameUser = newMemberID;
            } else if (this.sameUser === newMemberID) {
                this.sameUser = newMemberID;
            }
        }

        if (input.CardLists && input.CardLists.length) {
            this.memberCardNo = input.CardLists[0].CardNo;
            this.gscCoins = input.CardLists[0].PointsBAL;
            const newTierCode = input.CardLists[0].TierCode;

            if (!this.tierCode) {
                this.tierCode = newTierCode;
            } else if (this.tierCode === newTierCode) {
                this.tierCode = newTierCode;
            }
        }
    }

    setFromGuestLogin(input: GuestData): void {
        if (input) {
            this.userName = input.userName;
            this.guestData = {
                userName: input.userName,
                mobileNumber: input.mobileNumber,
                email: input.email,
            };
        }
    }

    firstTimeLogin(data: UpdateProfileModel | MemberEnquiry) {
        this.userName = data.MemberLists[0].Name;

        this.userMembershipInfo = {
            curdt: moment().format(),
            mbrid: data.MemberLists[0].MemberID,
            emailid: data.MemberLists[0].Email,
            phoneno: data.MemberLists[0].MobileNo,
            token: '1',
        };

        if (data.CardLists && data.CardLists.length) {
            this.memberCardNo = data.CardLists[0].CardNo;
        }
    }

    set memberInfo(data: GetTicketListingModel | null) {
        sessionStorage.setItem('memberInfo', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get memberInfo(): GetTicketListingModel | null {
        return sessionStorage.getItem('memberInfo')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('memberInfo') || '', this.secretKey).toString(Utf8)) as GetTicketListingModel
            : null;
    }

    set rewardsCenterListing(data: VoucherTypeList[] | []) {
        sessionStorage.setItem('rewardCenterList', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get rewardsCenterListing(): VoucherTypeList[] | [] {
        return sessionStorage.getItem('rewardCenterList')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('rewardCenterList') || '', this.secretKey).toString(Utf8)) as VoucherTypeList[]
            : [];
    }

    set seatSelectionData(data: SeatSelectionCacheMain | null) {
        sessionStorage.setItem('seatSelectionData', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get seatSelectionData(): SeatSelectionCacheMain | null {
        return sessionStorage.getItem('seatSelectionData')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('seatSelectionData') || '', this.secretKey).toString(Utf8)) as SeatSelectionCacheMain
            : null;
    }

    set confirmTicketTypeData(data: ConfirmTicketTypeCache | null) {
        sessionStorage.setItem('confirmTicketType', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get confirmTicketTypeData(): ConfirmTicketTypeCache | null {
        return sessionStorage.getItem('confirmTicketType')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('confirmTicketType') || '', this.secretKey).toString(Utf8)) as ConfirmTicketTypeCache
            : null;
    }

    set upsellProduct(data: any[] | null) {
        sessionStorage.setItem('upsellProduct', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get upsellProduct(): any[] | null {
        return sessionStorage.getItem('upsellProduct')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('upsellProduct') || '', this.secretKey).toString(Utf8)) as any[]
            : null;
    }

    set myRewardsDetails(data: MyVoucherList | null) {
        sessionStorage.setItem('myRewardsDetails', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get myRewardsDetails(): MyVoucherList | null {
        return sessionStorage.getItem('myRewardsDetails')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('myRewardsDetails') || '', this.secretKey).toString(Utf8)) as MyVoucherList
            : null;
    }

    set rewardDetails(data: VoucherTypeList | null) {
        sessionStorage.setItem('rewardDetails', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get rewardDetails(): VoucherTypeList | null {
        return sessionStorage.getItem('rewardDetails')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('rewardDetails') || '', this.secretKey).toString(Utf8)) as VoucherTypeList
            : null;
    }

    set otpToken(data: string | null) {
        sessionStorage.setItem('otpToken', AES.encrypt(data ?? '', this.secretKey).toString());
    }

    get otpToken(): string | null {
        return sessionStorage.getItem('otpToken') ? AES.decrypt(sessionStorage.getItem('otpToken') || '', this.secretKey).toString(Utf8) : '';
    }

    set otpCode(data: string | null) {
        sessionStorage.setItem('otpCode', AES.encrypt(data ?? '', this.secretKey).toString());
    }

    get otpCode(): string | null {
        return sessionStorage.getItem('otpCode') ? AES.decrypt(sessionStorage.getItem('otpCode') || '', this.secretKey).toString(Utf8) : '';
    }

    set countdownTime(data: number | null) {
        sessionStorage.setItem('countdownTime', AES.encrypt(data?.toString() ?? '', this.secretKey).toString());
    }

    get countdownTime(): number | null {
        return sessionStorage.getItem('countdownTime') ? Number(AES.decrypt(sessionStorage.getItem('countdownTime') || '', this.secretKey).toString(Utf8)) : null;
    }

    set dismissCount(data: number | null) {
        sessionStorage.setItem('dismissCount', AES.encrypt(data?.toString() ?? '', this.secretKey).toString());
    }

    get dismissCount(): number | null {
        return sessionStorage.getItem('dismissCount') ? Number(AES.decrypt(sessionStorage.getItem('dismissCount') || '', this.secretKey).toString(Utf8)) : null;
    }

    set upsellingEntryPoint(point: UpsellingType) {
        sessionStorage.setItem('hasUpselling', point.toString() ?? UpsellingType.NoUpselling);
    }

    get upsellingEntryPoint() {
        return Number(sessionStorage.getItem('hasUpselling')) ?? UpsellingType.NoUpselling;
    }

    set foodEntryPoint(point: MovieTicketType) {
        sessionStorage.setItem('foodEntryPoint', point.toString() ?? MovieTicketType.TicketWithoutEcombo);
    }

    get foodEntryPoint() {
        return Number(sessionStorage.getItem('foodEntryPoint')) ?? MovieTicketType.TicketWithoutEcombo;
    }

    set ecomboSelection(itm: SelectedVariationModel[]) {
        sessionStorage.setItem('ecomboSelection', AES.encrypt(JSON.stringify(itm) ?? [], this.secretKey).toString());
    }

    get ecomboSelection(): SelectedVariationModel[] {
        const data = sessionStorage.getItem('ecomboSelection');
        if (data) { return JSON.parse(AES.decrypt(data, this.secretKey).toString(Utf8)) as SelectedVariationModel[]; }
        return [];
    }

    clearUserInfo(): void {
        this.userName = '';
        this.accessToken = '';
        this.userMembershipInfo = null;
        this.profileQRToken = null;
        this.memberCardNo = '';
        this.clearFastTicket();
        this.guestData = null;
    }

    clearRegistrationInfo() {
        this.registrationInfo = null;
        this.countryCode = '';
        this.mobileNo = '';
        this.otpCode = '';
        this.otpToken = '';
    }

    clearSeatSelectionData() {
        this.seatSelectionData = null;
        this.selectedAddOnDetails = [];
        this.selectedAurumBundleDetails = [];
        this.selectedEcomboDetails = [];
    }

    clearConfirmTicketTypeInfo() {
        this.selectedAddOnDetails = [];
        this.selectedAurumBundleDetails = [];
        this.selectedEcomboDetails = [];
    }

    clearCacheRewardsData() {
        this.myRewardsDetails = null;
        this.rewardDetails = null;
    }

    clearCacheSelectedMovieTicket() {
        this.clearConfirmTicketTypeInfo();
        this.clearUserShowtimesSelection();
        this.clearSeatSelectionData();
        this.clearFnbData();
        this.selectedEcomboDetails = [];
        this.selectedAurumBundleDetails = [];
        this.lockSeatBody = null;
        this.bookingID = null;
        this.initSalesResponse = null;
        this.showtimesBannerDetails = null;
        this.upsellingEntryPoint = UpsellingType.NoUpselling;
        this.foodEntryPoint = MovieTicketType.TicketWithoutEcombo;
        this.ecomboSelection = [];
        this.recommendedShowtimes = null;
        this.selectedAddOnDetails = [];
        this.reviewSummaryEntry = null;
        this.reviewSummaryCountdown = 0;
        this.reviewSummaryTimerDiff = null;
        this.showtimesApiModel = null;
        this.upsellProduct = null;
        this.confirmTicketTypeData = null;
    }

    get chatName(): string {
        return AES.decrypt(sessionStorage.getItem('chatName') || '', this.secretKey).toString(Utf8);
    }

    set chatName(name: string) {
        sessionStorage.setItem('chatName', AES.encrypt(name || '', this.secretKey).toString());
    }

    get chatTime(): string {
        return AES.decrypt(sessionStorage.getItem('chatTime') || '', this.secretKey).toString(Utf8);
    }

    set chatTime(time: string) {
        sessionStorage.setItem('chatTime', AES.encrypt(time || '', this.secretKey).toString());
    }

    set coinsExpiryPopup(acc: any) {
        sessionStorage.setItem('coinsExpiry', AES.encrypt(JSON.stringify(acc), this.secretKey).toString());
    }

    get coinsExpiryPopup(): any | null {
        return sessionStorage.getItem('coinsExpiry')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('coinsExpiry') || '', this.secretKey).toString(Utf8))
            : null;
    }

    get recommendedShowtimes(): RecommendDetails | null {
        return sessionStorage.getItem('recommendedShowtimes')
            ? JSON.parse(AES.decrypt(sessionStorage.getItem('recommendedShowtimes') || '', this.secretKey).toString(Utf8))
            : null;
    }

    set recommendedShowtimes(data: RecommendDetails | null) {
        sessionStorage.setItem('recommendedShowtimes', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    set reviewSummaryEntry(url: string | null) {
        sessionStorage.setItem('reviewSummaryEntry', AES.encrypt(JSON.stringify(url) ?? null, this.secretKey).toString());
    }

    get reviewSummaryEntry(): string | null {
        return sessionStorage.getItem('reviewSummaryEntry') ? JSON.parse(AES.decrypt(sessionStorage.getItem('reviewSummaryEntry') || '', this.secretKey).toString(Utf8)) : null;
    }

    set reviewSummaryTimerDiff(timer: string | null) {
        sessionStorage.setItem('reviewSummaryTimerDiff', AES.encrypt(JSON.stringify(timer) ?? null, this.secretKey).toString());
    }

    get reviewSummaryTimerDiff(): string | null {
        return sessionStorage.getItem('reviewSummaryTimerDiff') ? JSON.parse(AES.decrypt(sessionStorage.getItem('reviewSummaryTimerDiff') || '', this.secretKey).toString(Utf8)) : null;
    }

    clearCoinsExpiryPopup() {
        this.coinsExpiryPopup = null;
    }

    set fnbData(data: FnbData | null) {
        sessionStorage.setItem('fnbData', AES.encrypt(JSON.stringify(data) ?? null, this.secretKey).toString());
    }

    get fnbData(): FnbData | null {
        return sessionStorage.getItem('fnbData') ? JSON.parse(AES.decrypt(sessionStorage.getItem('fnbData') || '', this.secretKey).toString(Utf8)) : null;
    }

    set fnbUpsell(data: FnbUpsell[] | null) {
        sessionStorage.setItem('fnbUpsell', AES.encrypt(JSON.stringify(data) ?? null, this.secretKey).toString());
    }

    get fnbUpsell(): FnbUpsell[] | null {
        return sessionStorage.getItem('fnbUpsell') ? JSON.parse(AES.decrypt(sessionStorage.getItem('fnbUpsell') ?? '', this.secretKey).toString(Utf8)) : null;
    }

    clearFnbData() {
        this.fnbData = null;
        this.fnbUpsell = null;
        this.selectedAddOnDetails = [];
        this.selectedEcomboDetails = [];
        this.ecomboSelection = [];
    }

    updateLockSeatData(updatedData: { member_name?: string, phoneno?: string, email?: string }) {
        const currentLockSeatBody = this.lockSeatBody;

        if (currentLockSeatBody) {
            const updatedBody = { ...currentLockSeatBody.Request.Body, ...updatedData };

            const updatedTransaction = new InitSalesTransaction({
                Request: new InitSalesRequestBody({
                    Header: currentLockSeatBody.Request.Header,
                    Body: updatedBody,
                }),
                Signature: currentLockSeatBody.Signature,
            });

            this.lockSeatBody = updatedTransaction;
        }
    }

    updateUpsellUserInfo(data: { phoneNo?: string; email?: string; memberName?: string }) {
        const current = this.upsellLockSeatBody;

        if (current) {
            const updated = new FnbSalesTransaction({
                ...current,
                PhoneNo: data.phoneNo ?? current.PhoneNo,
                EmailAddress: data.email ?? current.EmailAddress,
                MemberName: data.memberName ?? current.MemberName,
            });

            this.upsellLockSeatBody = updated;
        }
    }

    get guestMemberId() : string {
        if (environment.production === true) {
            return '7p9x94930265';
        }
        return 'hv1w41993692';
    }

    set showMemberOnboarding(data: boolean) {
        sessionStorage.setItem('showMemberOnboarding', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get showMemberOnboarding(): boolean {
        return sessionStorage.getItem('showMemberOnboarding') ? JSON.parse(AES.decrypt(sessionStorage.getItem('showMemberOnboarding') ?? '', this.secretKey).toString(Utf8)) as boolean : false;
    }

    get tierCode(): string {
        return AES.decrypt(sessionStorage.getItem('tierCode') || '', this.secretKey).toString(Utf8);
    }

    set tierCode(tierCode: string) {
        sessionStorage.setItem('tierCode', AES.encrypt(tierCode || '', this.secretKey).toString());
    }

    get sameUser(): string {
        const stored = AES.decrypt(sessionStorage.getItem('sameUser') || '', this.secretKey).toString(Utf8);
        return stored ? atob(stored) : '';
    }

    set sameUser(sameUser: string) {
        const encoded = btoa(sameUser || '');
        sessionStorage.setItem('sameUser', AES.encrypt(encoded, this.secretKey).toString());
    }

    set disableLoyalty(data: boolean) {
        sessionStorage.setItem('disableLoyalty', AES.encrypt(JSON.stringify(data), this.secretKey).toString());
    }

    get disableLoyalty(): boolean {
        return sessionStorage.getItem('disableLoyalty') ? JSON.parse(AES.decrypt(sessionStorage.getItem('disableLoyalty') ?? '', this.secretKey).toString(Utf8)) as boolean : false;
    }

    set returningToSeatSelection(value: boolean) {
        sessionStorage.setItem('returningToSeatSelection', AES.encrypt(JSON.stringify(value), this.secretKey).toString());
    }

    get returningToSeatSelection(): boolean {
        return sessionStorage.getItem('returningToSeatSelection') ? JSON.parse(AES.decrypt(sessionStorage.getItem('returningToSeatSelection') ?? '', this.secretKey).toString(Utf8)) as boolean : false;
    }
}
